import { phone } from 'phone';

export function phoneValidator(searchString: string, country?: string): string {
    if (searchString.startsWith('+')) {
        const phoneNumber = phone(searchString);
        if (phoneNumber.isValid) {
            return phoneNumber.phoneNumber;
        }
    }

    return searchString;
}
